var _rect, _rect2, _rect3, _path, _rect4, _circle, _path2, _path3, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMoMenuP04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.468,
    y: 22.4145,
    width: 17.1245,
    height: 10.4985,
    transform: "rotate(-32.5089 16.468 22.4145)",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3262,
    y: 11.7572,
    width: 3.74936,
    height: 13.4438,
    transform: "rotate(-32.5089 30.3262 11.7572)",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7016,
    y: 27.5097,
    width: 3.37441,
    height: 3.81164,
    transform: "rotate(-32.5089 28.7016 27.5097)",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7403 31.7792L34.4831 28.7566L39.1539 36.0857C39.9885 37.3954 39.6034 39.1338 38.2937 39.9684C36.984 40.8031 35.2457 40.418 34.411 39.1083L29.7403 31.7792Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2503,
    y: 23.3236,
    width: 3.74936,
    height: 13.4982,
    transform: "rotate(-32.5089 12.2503 23.3236)",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.648,
    cy: 8.76876,
    r: 8.01876,
    fill: "white",
    stroke: "#245FF8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.506 2.97021V9.19321L15.0318 12.4461",
    stroke: "#245FF8",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.23718 40.312C3.23718 39.0694 4.24454 38.062 5.48718 38.062H24.3618C25.6045 38.062 26.6118 39.0694 26.6118 40.312V42.7807H3.23718V40.312Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.3,
    y1: 42.7803,
    x2: 29.8496,
    y2: 42.7803,
    stroke: "#777777",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoMenuP04);
export default __webpack_public_path__ + "static/media/ic_mo_menu_p04.71b72486bb02e11b904ebf6e157730f0.svg";
export { ForwardRef as ReactComponent };